<script lang="ts">
  import { createEventDispatcher } from 'svelte';

  import { TextField } from '@shared/ui/fields/text-field';
  import { Icon } from '@shared/ui/icon';

  export let value: string;
  export let input: HTMLInputElement;
  export let isLoading: boolean;

  const dispatcher = createEventDispatcher<{ close: void; reset: void }>();

  function handleReset() {
    value = '';
    dispatcher('reset');
  }

  function handleClose() {
    dispatcher('close');
  }
</script>

<form class="flex w-full" on:submit|preventDefault>
  <div class="w-full">
    <TextField
      bind:value
      placeholder="Search for an artwork, artist..."
      name="search"
      noMargin
      containerClass="border-none w-full bg-transparent dark:bg-transparent"
      fieldClass="px-0 py-1 dark:placeholder:text-dark-700"
      on:input
      bind:input
    />
  </div>

  <div class="flex items-center gap-4">
    {#if value.trim()}
      {#if isLoading}
        <span
          class="bg-default-900 dark:text-default-50 animate-pulse !bg-clip-text
            text-base font-medium text-transparent"
        >
          Loading...
        </span>
      {:else}
        <button
          class="dark:text-default-50 text-default-900 text-base transition-opacity hover:opacity-80"
          type="reset"
          on:click="{handleReset}"
        >
          Clear
        </button>
      {/if}
    {/if}

    <button
      on:click="{handleClose}"
      type="button"
      class="after:dark:bg-default-50/10 after:bg-default-900/[6%] relative transition-opacity after:absolute after:top-1/2 after:h-8 after:w-8 after:-translate-x-1/2 after:-translate-y-1/2 after:rounded-full after:opacity-0 after:transition-opacity hover:opacity-80 after:hover:opacity-100"
    >
      <Icon name="close" classes="w-5 h-5" />
    </button>
  </div>
</form>
